import { BillingCardFields } from '@pages/BindQuote/BillingCard';

export function getUpdatedQuoteItemAttributes({
  quoteId,
  policyQuoteItem,
  attributeTypes,
  billingCardFields,
  isEndorsement,
  shouldIncludeBindAttributeType,
}: {
  quoteId: string;
  billingCardFields: BillingCardFields;
  policyQuoteItem: any;
  attributeTypes: any;
  isEndorsement: boolean | null;
  shouldIncludeBindAttributeType: boolean;
}) {
  const attributesArray = [
    {
      id: attributeTypes.street.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.street.id,
      value: billingCardFields.street.value,
    },
    {
      id: attributeTypes.street2.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.street2.id,
      value: billingCardFields.street2.value,
    },
    {
      id: attributeTypes.city.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.city.id,
      value: billingCardFields.city.value,
    },
    {
      id: attributeTypes.state.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.state.id,
      value: billingCardFields.state.value,
    },
    {
      id: attributeTypes.zip.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.zip.id,
      value: billingCardFields.zip.value,
    },
    {
      id: attributeTypes.primaryContact.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.primaryContact.id,
      value: billingCardFields.primaryContact.value,
    },
    {
      id: attributeTypes.emailAddress.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.emailAddress.id,
      value: billingCardFields.emailAddress.value,
    },
    {
      id: attributeTypes.phone.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.phone.id,
      value: billingCardFields.phone.value,
    },
    {
      id: attributeTypes.billPlan.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.billPlan.id,
      value: billingCardFields.billPlan.value,
    },
    {
      id: attributeTypes.billingMethod.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.billingMethod.id,
      value: billingCardFields.billingMethod.value,
    },
  ];

  if (isEndorsement) {
    attributesArray.push({
      id: attributeTypes.endorsementPaymentOption.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.endorsementPaymentOption.id,
      value: billingCardFields.endorsementPaymentOption.value,
    });
  }
  if (!isEndorsement && shouldIncludeBindAttributeType) {
    attributesArray.push({
      id: attributeTypes.binderInd.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.binderInd.id,
      value: billingCardFields.binderInd.value,
    });
    attributesArray.push({
      id: attributeTypes.bindingConditionsDetails.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.bindingConditionsDetails.id,
      value: billingCardFields.bindingConditionsDetails.value,
    });
  }

  const quoteItemAttributes = attributesArray.map((attribute) => ({
    value: attribute.value,
    id: attribute?.id,
    quoteItemAttributeTypeId: attribute.quoteItemAttributeTypeId,
  }));
  const request = {
    quoteId,
    quoteItems: [
      {
        id: policyQuoteItem.id,
        quoteItemAttributes,
      },
    ],
  };

  return request;
}
